import { Tab, Tabs } from '@mui/material';
import { useTheme } from 'styled-components';

import { useTabListContext } from './TabListContext';

function TabList() {
  const { tabList, activateTabItem, onTabClick } = useTabListContext();
  const theme = useTheme();

  if (tabList.length === 0) {
    console.warn('TabListProvider must have more than one tab item');
    return null;
  }

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    onTabClick(newValue);
  };

  return (
    <Tabs
      value={activateTabItem?.type}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        '& .MuiTabs-indicator': {
          height: '3px',
          background: theme.color.static.primary,
        },
        '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
          color: theme.color.static.primary,
        },
      }}
    >
      {tabList.map((tab) => (
        <Tab
          key={tab.type}
          label={tab.label}
          value={tab.type}
          sx={{
            fontFamily: 'Pretendard, Arial, sans-serif', // 폰트 설정
            fontWeight: 600,
            color: activateTabItem?.type === tab.type ? theme.color.static.primary : 'text.primary',
            fontSize: {
              xs: '20px',
              sm: '20px',
              md: '24px',
            },
            marginRight: '24px',
            padding: 0,
            minWidth: 'auto',
          }}
        />
      ))}
    </Tabs>
  );
}

export default TabList;
